import React, { useEffect, useState } from 'react'
import '../../index.less'
import { Col, Row, Spin } from 'antd'
import { buildingInfoByIdDetail,fetchGPList } from '@/services/customerServices'
import dayjs from "dayjs";

export default function InfoList(props: any) {
  const { id, onClose, visibleDrawer } = props
  const [allloading, setAllloading] = useState<boolean>(false)
  const [data, setBaseData] = useState<any>({})
  useEffect(() => {
    if (visibleDrawer) {
      initGetForm()
    }
  }, [visibleDrawer])
  // 是否编辑
  const isEdit = () => {
    return !!id
  }
  // 默认赋值
  const initGetForm = () => {
    if (isEdit()) {
      getInfoById(id)
    } else {
      setBaseData({})
      setAllloading(false)
    }
  }
  const getInfoById = (id: string) => {
    setAllloading(true)
    buildingInfoByIdDetail({ id, flag: true, handlflag: true })
        .then((response: any) => {
          const newValues = response || {}
          newValues.developStartDate = newValues.developStartDate
              ? dayjs(newValues.developStartDate).format('YYYY-MM-DD')
              : ''
          newValues.developEndDate = newValues.developEndDate
              ? dayjs(newValues.developEndDate).format('YYYY-MM-DD')
              : ''
          newValues.handoverDate = newValues.handoverDate
              ? dayjs(newValues.handoverDate).format('YYYY-MM-DD')
              : ''
          setBaseData(newValues)
          setAllloading(false)
        })
        .catch(() => {
          setAllloading(false)
        })
  }
  return (
    <Spin spinning={allloading}>
      <Row>
        <Col span={12} className="col">
          <div className="title" style={{minWidth: 120, textAlign: 'left'}}>楼盘编码：</div>
          <div className="span">{data.buildingCode}</div>
        </Col>
        <Col span={12} className="col">
          <div className="title" style={{minWidth: 120, textAlign: 'left'}}>楼盘名称：</div>
          <div className="span">{data.name}</div>
        </Col>
        <Col span={12} className="col">
          <div className="title" style={{minWidth: 120, textAlign: 'left'}}>所在城市：</div>
          <div className="span">
            {data.provinceName}-{data.cityName}
          </div>
        </Col>
        <Col span={12} className="col">
          <div className="title" style={{minWidth: 120, textAlign: 'left'}}>楼盘均价：</div>
          <div className="span">{data.price}</div>
        </Col>
        <Col span={12} className="col">
          <div className="title" style={{minWidth: 120, textAlign: 'left'}}>楼盘所属区域：</div>
          <div className="span">{data.buildingAreaName}</div>
        </Col>
        <Col span={12} className="col">
          <div className="title" style={{minWidth: 120, textAlign: 'left'}}>交房时间：</div>
          <div className="span">{data.handoverDate}</div>
        </Col>
        <Col span={12} className="col">
          <div className="title" style={{minWidth: 120, textAlign: 'left'}}>门店：</div>
          <div className="span">{data.companyName}</div>
        </Col>
        <Col span={12} className="col">
          <div className="title" style={{minWidth: 120, textAlign: 'left'}}>楼盘面积区间：</div>
          <div className="span">{data.areaRange}</div>
        </Col>
        <Col span={12} className="col">
          <div className="title" style={{minWidth: 120, textAlign: 'left'}}>开发商：</div>
          <div className="span">{data.estateDeveloperName}</div>
        </Col>
        <Col span={12} className="col">
          <div className="title" style={{minWidth: 120, textAlign: 'left'}}>楼盘户数：</div>
          <div className="span">{data.houseNumber}</div>
        </Col>
        <Col span={12} className="col">
          <div className="title" style={{minWidth: 120, textAlign: 'left'}}>是否重点楼盘：</div>
          <div className="span">
            {data.emphasisFlag == 1 ? '重点' : data.emphasisFlag == '0' ? '非重点' : ''}
          </div>
        </Col>
        <Col span={12} className="col">
          <div className="title" style={{minWidth: 120, textAlign: 'left'}}>远程费金额：</div>
          <div className="span">{data.remoteFee}</div>
        </Col>
        <Col span={12} className="col">
          <div className="title" style={{minWidth: 120, textAlign: 'left'}}>楼盘地址：</div>
          <div className="span">{data.address}</div>
        </Col>
        <Col span={12} className="col">
          <div className="title" style={{minWidth: 120, textAlign: 'left'}}>经度：</div>
          <div className="span">{data.longitude}</div>
        </Col>
        <Col span={12} className="col">
          <div className="title" style={{minWidth: 120, textAlign: 'left'}}>纬度：</div>
          <div className="span">{data.latitude}</div>
        </Col>
        <Col span={12} className="col">
          <div className="title" style={{minWidth: 120, textAlign: 'left'}}>主力面积：</div>
          <div className="span">{data.mainArea || ''}</div>
        </Col>
        <Col span={12} className="col">
          <div className="title" style={{minWidth: 120, textAlign: 'left'}}>开发起止时间：</div>
          <div className="span">
            {data.developStartDate || ''} ~ {data.developEndDate || ''}
          </div>
        </Col>
        <Col span={12} className="col">
          <div className="title" style={{minWidth: 120, textAlign: 'left'}}>开发周期：</div>
          <div className="span">
            {data.developTotalDates}
          </div>
        </Col>
        <Col span={12} className="col">
          <div className="title" style={{minWidth: 120, textAlign: 'left'}}>深耕费用计划合计：</div>
          <div className="span">{data.plannedCosts || ''}</div>
        </Col>
        <Col span={12} className="col">
          <div className="title" style={{minWidth: 120, textAlign: 'left'}}>开发部门：</div>
          <div className="span">{data.developDeptName || ''}</div>
        </Col>
        <Col span={12} className="col">
          <div className="title" style={{minWidth: 120, textAlign: 'left'}}>楼盘属性：</div>
          <div className="span">
            {data.financialAttr == 1 ? 'F' : data.financialAttr == 0 ? '非F' : ''}
          </div>
        </Col>
        <Col span={12} className="col">
          <div className="title" style={{minWidth: 120, textAlign: 'left'}}>立项期楼盘状态：</div>
          <div className="span">{data.constructionStatName || ''}</div>
        </Col>
        <Col span={12} className="col">
          <div className="title" style={{minWidth: 120, textAlign: 'left'}}>签单目标(万元)：</div>
          <div className="span">{data.signingTarget || ''}</div>
        </Col>
        <Col span={12} className="col">
          <div className="title" style={{minWidth: 120, textAlign: 'left'}}>门店距离(KM)：</div>
          <div className="span">{data.companyDistance || ''}</div>
        </Col>
      </Row>
    </Spin>
  )
}
